import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatePipe, Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiService } from '../../service/api.service';
import { DataServiceService } from '../../service/data-share.service';
import { CommonService } from '../../service/common.service';
import { SuccessComponent } from '../../shared/success/success.component';
import { MatDialog } from '@angular/material/dialog';

import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-product-checkout',
  templateUrl: './product-checkout.component.html',
  styleUrls: ['./product-checkout.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule]
})
export class ProductCheckoutComponent implements OnInit, OnDestroy {
  subscription!: Subscription;
  addressData: any = [];
  carts: any = [];
  userData: any = {};
  qty: any = 1;
  addressForm!: FormGroup;
  addressIds: any = '';
  paymentModes: any = '';
  totalProductIds: any;
  isLoading: boolean = true;
  private addressLoaded: boolean = false;
  private cartLoaded: boolean = false;

  private checkLoading() {
    if (this.addressLoaded && this.cartLoaded) {
      this.isLoading = false;
    }
  }

  paymentMode: any = [
    {
      status: true,
      viewValue: 'Cash On Delivery',
      value: 'COD',
    },
    {
      status: false,
      viewValue: 'Credit / Debit / ATM Card',
      value: 'Card',
    },
    {
      status: false,
      viewValue: 'Net Banking',
      value: 'NET BANKING',
    },
  ];
  addressUser: boolean = true;
  addressAddUser: boolean = false;

  totalItems: any = 0;
  totalAmounts: any = 0;
  discountAmounts: any = 0;
  deliverCharges: any = 0;
  plateformFee: any = 0;
  grandTotal: any = 0;
  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private _service: CommonService,
    private api: ApiService,
    private dataShare: DataServiceService,
    public _location: Location,
    private model: MatDialog
  ) {
    if (localStorage.getItem('userData')) {
      const u: any = localStorage.getItem('userData');
      this.userData = JSON.parse(u);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      this._location.back();
    }
  }

  ngOnInit(): void {
    this.addressForm = this.fb.group({
      address: ['', [Validators.required, Validators.minLength(5)]],
      landmark: ['', [Validators.required]],
      city: ['', [Validators.required]],
      district: ['', [Validators.required]],
      state: ['', [Validators.required]],
      pincode: ['', [Validators.required, Validators.pattern(/^[1-9][0-9]{5}$/)]],
      country: ['', [Validators.required]],
    });
    this.getAllUserAddress();
    this.getAllCartData();
  }

  getAllUserAddress() {
    const body = {
      user_id: this.userData.id,
    };
    this.subscription = this.api
      .commonPost('users/fetch/address', body)
      .subscribe(
        (res: any) => {
          this.addressLoaded = true;
          this.checkLoading();
          if (res.status && res.statusCode == 200 && res.response.length > 0) {
            res.response.forEach((element: any) => {
              element.check = false;
            });
            res.response[0].check = true;
            this.addressIds = res.response[0].id;
            this.addressData = res.response;
          } else {
            this.addressData = [];
            this.addressAddUser = true;
          }
        },
        (error: any) => {
          this.addressLoaded = true;
          this.checkLoading();
          console.log(error);
        }
      );
  }

  addUserAddress() {
    if (this.addressForm.invalid) {
      this.addressForm.markAllAsTouched();
      return;
    }
    const body = {
      user_id: this.userData.id,
      address: this.addressForm.value.address?.trim(),
      landmark: this.addressForm.value.landmark?.trim(),
      city: this.addressForm.value.city?.trim(),
      state: this.addressForm.value.state?.trim(),
      district: this.addressForm.value.district?.trim(),
      pincode: this.addressForm.value.pincode?.toString().trim(),
      country: this.addressForm.value.country?.trim(),
    };
    this.subscription = this.api
      .commonPost('users/register/address', body)
      .subscribe(
        (res: any) => {
          if (res.status && res.statusCode == 201) {
            this.addressForm.reset();
            this.addressAddUser = false;
            this.getAllUserAddress();
          }
        },
        (error) => console.log(error)
      );
  }

  allowAddressCharacters(event: KeyboardEvent): boolean {
    const charCode = event.which || event.keyCode;
    const char = String.fromCharCode(charCode);
    const regex = /^[a-zA-Z0-9 ,/.\-#]$/;

    if (!regex.test(char)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  allowAlphaSpaceComma(event: KeyboardEvent): boolean {
    const charCode = event.which || event.keyCode;
    const char = String.fromCharCode(charCode);
    const regex = /^[a-zA-Z ,]$/;

    if (!regex.test(char)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  getAllCartData() {
    const body = {
      user_id: this.userData.id,
    };
    this.totalProductIds = [];
    this.subscription = this.api
      .commonPost('product/get/addToCart', body)
      .subscribe(
        (res: any) => {
          this.cartLoaded = true;
          this.checkLoading();
          if (res.status && res.statusCode == 200) {
            res.response.forEach((ele: any) => {
              ele.url = this.api.imageUrl + ele.data[0].url;
              this.totalItems += ele.quantity;
              ele.amounts = (parseFloat(ele.productPrice) * ele.quantity).toFixed(2);
              this.totalAmounts += parseFloat(ele.amounts);
              this.totalProductIds.push({
                productId: ele.product_id,
                qty: ele.quantity,
              });

            });
            this.carts = res.response;
            this.getPriceCalculation();
          } else {
            this.totalProductIds = [];
            this.carts = [];
            this.router.navigate(['/']);
          }
        },
        (error: any) => {
          this.cartLoaded = true;
          this.checkLoading();
          console.log(error);
        }
      );
  }


  getPriceCalculation() {
    this.grandTotal = this.totalAmounts - this.discountAmounts + this.deliverCharges + this.plateformFee;
  }

  addQty(data: any, i: any) {
    let qty = data.quantity + 1;
    this.carts[i].quantity = qty;
    this.addQtyMore(qty, data?.product_id);
  }

  subtractQty(data: any, i: any) {
    let qty = data.quantity - 1;
    this.carts[i].quantity = qty;
    if (qty == 0) {
      this.removeCartPro(data.cart_id, data.product_id);
    } else {
      this.addQtyMore(qty, data?.product_id);
    }
  }

  addQtyMore(quantity: any, product_id: any) {
    const body = {
      user_id: this.userData.id,
      quantity: quantity,
      product_id: product_id,
    };
    this.subscription = this.api
      .commonPost('create/product/addToCart', body)
      .subscribe(
        (res: any) => {
          if (res.status && res.statusCode == 200) {
            this.getAllCartData();
          } else {
          }
        },
        (error: any) => console.log(error)
      );
  }
  removeCartPro(cart_id: any, product_id: any) {
    const body = {
      user_id: this.userData.id,
      cart_id: cart_id,
      product_id: product_id,
    };
    this.subscription = this.api
      .commonPost('create/product/remove/addToCart', body)
      .subscribe(
        (res: any) => {
          if (res.status && res.statusCode == 200) {
            this.getAllCartData();
            this.dataShare.passValue('');
          } else {
          }
        },
        (error: any) => console.log(error)
      );
  }

  numberOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  update(e: any, data: any) {
    this.addressData.forEach((element: any) => {
      if (data.id == element.id) {
        element.check = true;
        this.addressIds = data.id;
      } else {
        element.check = false;
      }
    });
  }
  selectPaymentMode(e: any, data: any) {
    this.paymentMode.forEach((ele: any) => {
      if (ele.value == data.value && e) {
        ele.status = true;
        this.paymentModes = data.value;
      } else {
        ele.status = false;
      }
    });
  }

  orderPlaced() {
    if (!this.paymentModes) {
      this.model.open(SuccessComponent, {
        width: '300px',
        disableClose: true,
        data: { type: 'error', message: 'Please select payment mode.' },
      });
    } else if (!this.addressIds) {
      this.model.open(SuccessComponent, {
        width: '300px',
        disableClose: true,
        data: { type: 'error', message: 'Please select address.' },
      });
    }
    else {
      const body = {
        user_id: this.userData.id,
        address_id: this.addressIds,
        product: JSON.stringify(this.totalProductIds),
        coupon_code: '',
        total_amount: this.grandTotal,
        totalDiscountAmount: this.discountAmounts,
        paybal_amount: this.grandTotal,
        payment_mode: this.paymentModes,
        qty: this.totalItems,
      };
      this.subscription = this.api
        .commonPost('create/product/checkout', body)
        .subscribe(
          (res: any) => {
            if (res.status && res.statusCode == 200) {
              this.model.open(SuccessComponent, {
                width: '300px',
                disableClose: true,
                data: { type: 'success', message: res.message },
              });
              this.dataShare.passValue('');
              this.router.navigate(['/']);
            } else {
              this.model.open(SuccessComponent, {
                width: '300px',
                disableClose: true,
                data: { type: 'error', message: res.message },
              });
            }
          },
          (error: any) => console.log(error)
        );
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) this.subscription.unsubscribe();
  }
}
